import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { ActionCode, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { toJS } from 'mobx';
import VerticalForm from '../common/form/VerticalForm';
import { CheckboxInputFormField, SelectInputFormField, TextInputFormField } from '../common/form';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Form } from 'react-final-form';
import LanguageFormField from '../common/form/LanguageFormField';
import DayOfWeekFormField from '../common/form/DayOfWeekFormField';
import GroupFormField from '../common/form/GroupFormField';
import MunicipalityFormField from '../common/form/MunicipalityFormField';
import { Button, Intent, InputGroup, Radio, RadioGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Pharmacy } from '../../store/models/Pharmacy';
import styled from '@emotion/styled';
import UserFormField from '../common/form/UserFormField';
import { User } from '../../store/models/User';
import { Group } from '../../store/models/Group';
import { Municipality } from '../../store/models/Municipality';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { AuthenticationStore, PharmacyDetailedStore, DutyOffRequestStore, GroupStore } from '../../store';
import SecretariatFormField from '../common/form/SecretariatFormField';
import { Secretariat } from '../../store/models';


interface PharmacyFormProps extends WithTranslateProps {
  pharmacy?: Instance<typeof Pharmacy>;
  userList?: Array<Instance<typeof User>>;
  groupList?: Array<Instance<typeof Group>>;
  municipalityList?: Array<Instance<typeof Municipality>>;
  secretariatList?: Array<Instance<typeof Secretariat>>;
  save: (data: any) => void;
  // refreshGeoData: (data: any) => void;
  userRoles: string[];
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  DutyOffRequestStore?: Instance<typeof DutyOffRequestStore>;
}

interface PharmacyFormState {
  loading: boolean;
  user: any;
  level: any;
  // isActive: any;
  isGroupMandatory: boolean;
  checkStartYear: string;
}

@inject('AuthenticationStore')
@inject('PharmacyDetailedStore')
@inject('DutyOffRequestStore')
@observer
class PharmacyForm extends React.Component<PharmacyFormProps, PharmacyFormState> {
  constructor(props: PharmacyFormProps) {
    super(props);
    this.state = {
      loading: false,
      user: this.props.userList!.filter((u) => u.userId == this.props.pharmacy!['userId'])[0],
      level: this.props.pharmacy!['level'],
      isGroupMandatory: this.props.pharmacy!['level'] === 3 && this.props.pharmacy!['isActive'],
      checkStartYear: new Date().getFullYear().toString(),
    };
  }

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  resetPassword = async () => {
    await this.props.AuthenticationStore!.resetPasswordByPharmacyId(this.props.pharmacy!.pharmacyId);
  };

  acceptLevel0 = () => {
    // this.props.pharmacy!.level = 0;
  };

  rejectLevel0 = () => {
    // this.props.pharmacy!.level = -1;
  };

  canEditPharmacy = () => {
    return (
      this.props.AuthenticationStore!.isSuperAdmin ||
      (this.props.pharmacy !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === this.props.pharmacy!.secretariatId)
    );
  };

  refreshGeoData = async () => {
    this._isMounted && this.setState({ loading: true });
    await this.props.PharmacyDetailedStore!.updatePharmacyGeoData(this.props.pharmacy!.pharmacyId);
    this._isMounted && this.setState({ loading: false });
  };

  onCheckStartYearChanged = (value) => {
    this.setState({ checkStartYear: value });
  };

  checkDutyOffRequests = async () => {
    this._isMounted && this.setState({ loading: true });
    await this.props.DutyOffRequestStore!.checkPharmacyDutyOffRequests(
      this.state.checkStartYear,
      this.props.pharmacy!.apbNumber.toString(),
    );
    this._isMounted && this.setState({ loading: false });
  };

  onLevelChange = (value) => {
    this.setState({ level: value });
  };

  toggleActiveFlag = (value) => {
    // this.setState({ isGroupMandatory: value.target.checked && this.state.level === "3" });
    // this.setState({ isActive: value.target.checked, isGroupMandatory: value.target.checked && this.state.level === "3" });
  };

  private impersonate = (ev) => {
    const { AuthenticationStore, userList, pharmacy } = this.props;
    const user = userList!.filter((u) => u.userId == pharmacy!['userId'])[0];
    AuthenticationStore!.impersonate(user['userName']);
  };

  public render() {
    const { pharmacy, translate, save, userList, userRoles, groupList, municipalityList, secretariatList } = this.props;
    const canEdit = userRoles.includes(ActionCode.ADMIN_CODE) || userRoles.includes(ActionCode.SECRETARY_USER_CODE);
    const isGroupMandatory = this.state.isGroupMandatory;

    return (
      <Form
        initialValues={toJS(pharmacy) || {}}
        onSubmit={save}
        render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <LeaveRouteDirtyWrapper blockChange={dirty} />
            <Container>
              <VerticalForm labelWidth={105}>
                <DivLine>
                  <DivColumn>
                    <TextInputFormField
                      name="apbNumber"
                      required={true}
                      label={TLCode.PHARMACY_ApbNr}
                      inline={true}
                      fill={true}
                      validate={[]}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn style={{ width: 160}}>
                    <TextInputFormField
                      name="level"
                      label={TLCode.PHARMACY_Level}
                      inline={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn style={{ width: 160}}>
                    <SimpleTextFormContent label={TLCode.PHARMACY_IsActive} small={false}>
                      <CheckboxInputFormField
                        name="isActive"
                        inline={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                        onChange={this.toggleActiveFlag}
                      />
                    </SimpleTextFormContent>
                  </DivColumn>
                  {this.props.AuthenticationStore!.isSuperAdmin && (
                    <DivColumn>
                      <DivLine>
                        <Button
                          text={translate(TLCode.USER_Impersonate)}
                          icon={IconNames.PEOPLE}
                          intent={Intent.DANGER}
                          onClick={this.impersonate}
                        />
                      </DivLine>
                    </DivColumn>
                  )}
                </DivLine>
                <DivLine>
                  <DivColumn>
                    <TextInputFormField
                      name="name"
                      required={true}
                      label={TLCode.PHARMACIES_PharmacyName}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn style={{ width: 320}}>
                    <UserFormField name="userId" userList={userList} disabled={!canEdit || !this.canEditPharmacy()} />
                  </DivColumn>
                  <DivColumn style={{ width: 300}}>
                    {this.state.user && (
                      <a href={'mailto:' + this.state.user.email + '?subject=Pharmagarde'}>{this.state.user.email}</a>
                    )}
                  </DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn style={{ minWidth:250, width:250}}>
                    <TextInputFormField
                      name="phone"
                      label={TLCode.PHARMACY_Phone}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn style={{ minWidth:250, width:250}}>
                    <TextInputFormField
                      name="mobile"
                      label={TLCode.PHARMACY_Mobile || !this.canEditPharmacy()}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn style={{ width: 160}}>
                    <SimpleTextFormContent label={TLCode.PHARMACY_ReceivesSms} small={false}>
                      <CheckboxInputFormField
                        name="receivesSms"
                        inline={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                    </SimpleTextFormContent>
                  </DivColumn>
                  <DivColumn>
                    <LanguageFormField name="language" required={true} disabled={!canEdit || !this.canEditPharmacy()} />
                  </DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn style={{ width: '50%' }}>
                    <TextInputFormField
                      name="address"
                      label={TLCode.PHARMACIES_Address}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn style={{ width: '40%' }}>
                        <TextInputFormField
                          name="city"
                          label={TLCode.PHARMACIES_City}
                          inline={true}
                          fill={true}
                          disabled={!canEdit || !this.canEditPharmacy()}
                        />
                      </DivColumn>
                      <DivColumn style={{ width: '20%' }}>
                        <TextInputFormField
                          name="zipCode"
                          label={TLCode.PHARMACIES_ZipCode}
                          inline={true}
                          fill={true}
                          disabled={!canEdit || !this.canEditPharmacy()}
                        />
                      </DivColumn>
                  <DivColumn style={{ width: '40%' }}>
                    <MunicipalityFormField
                      label={TLCode.PHARMACIES_Municipality}
                      municipalityList={municipalityList}
                      disabled={!canEdit}
                      isClearable={false}
                    />
                  </DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn50>
                    <TextInputFormField
                      name="anchor"
                      label={TLCode.PHARMACY_Anchor}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn50>
                  <DivColumn50>
                    <GroupFormField
                      label={TLCode.PHARMACIES_Group}
                      name="group"
                      groupList={groupList}
                      disabled={!canEdit || !this.canEditPharmacy()}
                      isClearable={true}
                    />
                  </DivColumn50>
                </DivLine>
                {(canEdit || this.canEditPharmacy()) && (
                  <DivLine>
                    <DivColumn>
                      <DayOfWeekFormField
                        label={TLCode.PHARMACY_PrefDayOff}
                        name="prefDutyDayOff"
                        required={false}
                        disabled={!canEdit || !this.canEditPharmacy()}
                        labelSelectAnElement={''}
                      />
                    </DivColumn>
                    <DivColumn50>
                      <SecretariatFormField
                        label={TLCode.SECRETARIAT}
                        name="secretariatId"
                        secretariatList={secretariatList}
                        disabled={!this.props.AuthenticationStore!.isSuperAdmin}
                      />
                    </DivColumn50>
                    <DivColumn>
                      <SimpleTextFormContent label={TLCode.PHARMACY_IsContributing} small={false}>
                      <CheckboxInputFormField
                        name="isContributing"
                        inline={true}
                        disabled={!canEdit || !this.canEditPharmacy()}
                      />
                      </SimpleTextFormContent>
                    </DivColumn>
                  </DivLine>
                )}
                <DivLine></DivLine>
                <DivLine>
                  <DivColumn>
                    <TextInputFormField
                      name="x"
                      label={TLCode.PHARMACY_X_Lambert2008}
                      inline={true}
                      fill={true}
                      disabled={!canEdit}
                    />
                  </DivColumn>
                  <DivColumn>
                    <TextInputFormField
                      name="y"
                      label={TLCode.PHARMACY_Y_Lambert2008}
                      inline={true}
                      fill={true}
                      disabled={!canEdit}
                    />
                  </DivColumn>
                  <DivColumn></DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn>
                    <TextInputFormField
                      name="latitude"
                      label={TLCode.PHARMACY_Latitude}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                    <TextInputFormField
                      name="minDistance"
                      label={TLCode.PHARMACY_DayMinDistance}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                    <TextInputFormField
                      name="minDistance2"
                      label={TLCode.PHARMACY_NightMinDistance}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn>
                    <TextInputFormField
                      name="longitude"
                      label={TLCode.PHARMACY_Longitude}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                    <TextInputFormField
                      name="maxDistance"
                      label={TLCode.PHARMACY_DayMaxDistance}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                    <TextInputFormField
                      name="maxDistance2"
                      label={TLCode.PHARMACY_NightMaxDistance}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                  <DivColumn>
                    <TextInputFormField
                      name="density"
                      label={TLCode.PHARMACY_Density}
                      inline={true}
                      fill={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                    <Button
                      text={translate(TLCode.PHARMACY_RefreshGeoData)}
                      icon={IconNames.REFRESH}
                      intent={Intent.DANGER}
                      onClick={this.refreshGeoData}
                      hidden={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                </DivLine>
                <DivLine>
                  {this.canEditPharmacy() && (
                    <DivColumn>
                      <DivLine>
                        <InputGroup
                          placeholder="year to start checking"
                          value={this.state.checkStartYear}
                          onChange={(e) => this.onCheckStartYearChanged(e.target.value)}
                        />
                        <Button
                          intent={Intent.PRIMARY}
                          onClick={this.checkDutyOffRequests}
                          text={translate(TLCode.PHARMACY_CheckDutyOffRequests)}
                        />
                      </DivLine>
                    </DivColumn>
                  )}
                  <DivColumn>
                    <Button
                      text={translate(TLCode.LOGIN_ResetPassword)}
                      icon={IconNames.RESET}
                      intent={Intent.DANGER}
                      onClick={this.resetPassword}
                      hidden={!canEdit || !this.canEditPharmacy()}
                    />
                  </DivColumn>
                </DivLine>
                <DivLine>
                  {/* <SimpleTextFormContent label={TLCode.PHARMACY_IsActive} small={false}>
                    <CheckboxInputFormField
                      name="isActive"
                      inline={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                      onChange={this.toggleActiveFlag}
                    />
                  </SimpleTextFormContent> */}
                  {/* <SimpleTextFormContent label={TLCode.PHARMACY_IsContributing} small={false}>
                    <CheckboxInputFormField
                      name="isContributing"
                      inline={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </SimpleTextFormContent> */}
                  {/* <SimpleTextFormContent label={TLCode.PHARMACY_ReceivesSms} small={false}>
                    <CheckboxInputFormField
                      name="receivesSms"
                      inline={true}
                      disabled={!canEdit || !this.canEditPharmacy()}
                    />
                  </SimpleTextFormContent> */}
                </DivLine>
              </VerticalForm>
              {canEdit && (
                <>
                <br/>
                <ButtonsContainer>
                  <Button
                    text={translate(TLCode.GENERAL_Cancel)}
                    icon={IconNames.ERASER}
                    intent={Intent.PRIMARY}
                    onClick={() => form.reset()}
                    disabled={!dirty || !this.canEditPharmacy()}
                  />
                  <Button
                    type={'submit'}
                    text={translate(TLCode.GENERAL_Save)}
                    icon={IconNames.FLOPPY_DISK}
                    intent={Intent.PRIMARY}
                    disabled={hasValidationErrors || !dirty || !this.canEditPharmacy()}
                  />
                </ButtonsContainer>
                </>
              )}
            </Container>
          </form>
        )}
      />
    );
  }
}

export default withTranslate(PharmacyForm);

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

const DivColumn50 = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  width: 50%;
`;

const DivColumn25 = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  width: 25%;
`;

const Container = styled.div({
  display: 'flex',
  width: '70%',
  flexDirection: 'column',
});

const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: 5,
  },
});

const ContrainerCheckbox = styled.div({
  display: 'flex',
  flexDirection: 'column',
  '& .bp3-form-group': {
    marginBottom: '0px',
  },
});